import React from 'react';
import styles from './FooterAguardandoCliente.module.css';
import Icon from '@mdi/react';
import { mdiAccountClock } from '@mdi/js';

type FooterAguardandoClienteProps = {};

const FooterAguardandoCliente = ({}: FooterAguardandoClienteProps) => {
    return (
        <div className={styles[`footer-status-aguardando-cliente`]}>
            <div style={{ fontWeight: '600', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '4px' }}>
                <Icon path={mdiAccountClock} size="20px" />
                Aguardando cliente
            </div>
            <div>
                Aguardando a resposta do cliente.
            </div>
        </div>
    );
};

export default FooterAguardandoCliente;
